var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsIconMarketplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 6.6665V13.3332M2.66699 9.99984H13.3337M2.66699 6.6665H13.3337M4.56329 13.3332H11.4374C12.1011 13.3332 12.433 13.3332 12.6865 13.1878C12.9095 13.06 13.0909 12.856 13.2045 12.6052C13.3337 12.32 13.3337 11.9466 13.3337 11.1998V4.79984C13.3337 4.0531 13.3337 3.67973 13.2045 3.39452C13.0909 3.14363 12.9095 2.93966 12.6865 2.81183C12.433 2.6665 12.1011 2.6665 11.4374 2.6665H4.56329C3.89953 2.6665 3.56764 2.6665 3.31412 2.81183C3.0911 2.93966 2.9098 3.14363 2.79617 3.39452C2.66699 3.67973 2.66699 4.0531 2.66699 4.79984V11.1998C2.66699 11.9466 2.66699 12.32 2.79617 12.6052C2.9098 12.856 3.0911 13.06 3.31412 13.1878C3.56764 13.3332 3.89952 13.3332 4.56329 13.3332Z",
    stroke: "#666666",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIconMarketplace);
export default __webpack_public_path__ + "static/media/docsIconMarketplace.bb5300148aa4fb99597f88d5555752d1.svg";
export { ForwardRef as ReactComponent };